<template lang="pug">
  div.invoice-control.bank-statement-items-link-create
    e-modal(
      ref="modalForm"
      @confirm="sendForm()"
      @close="closeForm()"
      saveBtnLabel="Привязать"
      title="Привязка"
      :hideDeleteButton="false"
      :centered="true"
      :autoHeight="true"
    )
      slot
        e-form(
          :formValidator="formValidator"
          :enablePerfectScrollbar="false"
          formClass="fix-elements-overflow-problem"
        )
          div.body
            div.col

              e-form-group(
                inputType="suggestion"
                label="№ пачки"
                name="bankPacketName"
                realName="bank_packet_id"
                validateAlias="bank_packet_id"
                :model="fields"
                tabView="tab1"
                :required="true"
                :minSuggestLen="2"
                :suggestionEndpoint="suggestionEndpoint"
                :transformSuggestions="transformSuggestions"
                @selectItem="selectItem"
                :useInnerSearch="false"
              )
              e-form-group(
                label="Дата пачки"
                name="_dt_formed"
                :model="fields"
                tabView="tab1"
                :disabled="true"
              )
              e-form-group(
                label="Банк"
                name="_billing_bank"
                :model="fields"
                tabView="tab1"
                :disabled="true"
              )

</template>

<script>
  import formBaseMixin from '../../components/form/form-base-mixin.js'
  import {bankPackets, invoiceControl} from "../../api/api-endpoints"

  export default {
    mixins: [formBaseMixin],
    data () {
      return {
        fields: {
          bank_packet_id: '',
          statement_id: '',
          _billing_bank: '',
          _dt_formed: ''
        }
      }
    },
    methods: {
      /**
       * @override
       */
      onSuccess () {
        this.$emit('success')
        formBaseMixin.methods.onSuccess.call(this)
      },
      getUpdateOrCreateUrl () {
        return invoiceControl.bankStatementItemLinkCreate()
      },
      /**
       * @override
       */
      getRedirectParams () {
        const route = formBaseMixin.methods.getRedirectParams.call(this)
        route.query.sort = '-last_updated_at'
        return route
      },
      closeForm () {
        this.$refs.modalForm.redirectToPrev()
      },
      /**
       * @override
       */
      getSuccessTitle () {
        return null
      },
      suggestionEndpoint (ctx, q) {
        return bankPackets.uploadedPackets({
          query: {
            q,
            'per-page': 50,
            statementId: this.fields.statement_id
          }
        })
      },
      transformSuggestions (ctx, data) {
        return data.data.map(item => {
          return {
            id: item.id,
            name: `Банковская пачка № ${item.number || item.id} от ${item.dt_formed}, банк: ${item.billing_bank}`,
            item
          }
        })
      },
      selectItem ($event) {
        if ($event && $event.id) {
          this.fields.bank_packet_id = $event.id
          this.fields.bankPacketName = $event.name
          this.fields._billing_bank = $event.item.billing_bank || '-'
          this.fields._dt_formed = $event.item.dt_formed || '-'
        } else {
          this.fields.bank_packet_id = ''
          this.fields.bankPacketName = ''
          this.fields._billing_bank = ''
          this.fields._dt_formed = ''
        }
      }
    }
  }
</script>
